(() => {
  const base = 'https://udrrkckxysjzigwvzpyx.supabase.co/functions/v1/';
  const init = () => document.querySelectorAll('[data-atelier-single-stock]').forEach(widget => {
    if (widget.dataset.ready) return;
    widget.dataset.ready = 'true';
    const root = widget.closest('[data-atelier-pdp]');
    const variants = JSON.parse(widget.querySelector('[data-stock-variants]').textContent);
    const status = widget.querySelector('[data-stock-status]');
    const trigger = root.querySelector('[data-restock-trigger]');
    const form = root.querySelector('[data-restock-form]');
    const buyButtons = [...root.querySelectorAll('[data-add-to-cart], .btn-for-popup, .shopify-payment-button')];
    let selected = variants.find(variant => String(variant.id) === widget.dataset.initialVariant);
    let positions = new Map();
    let loaded = false;
    const render = () => {
      const position = positions.get(String(selected?.id));
      const soldOut = selected && (!selected.available || (position?.inStock === false && !selected.backorder));
      let text = 'Kies een beschikbare combinatie';
      let state = 'unavailable';
      if (selected) {
        if (soldOut) text = 'Uitverkocht - momenteel niet bestelbaar';
        else if (!loaded) { text = 'Beschikbaarheid controleren...'; state = 'unknown'; }
        else if (!position || position.inStock === null) { text = 'Bestelbaar - verzendtijd momenteel niet beschikbaar'; state = 'unknown'; }
        else if (position.inStock) { text = 'Op voorraad - binnen 1-2 werkdagen verzonden'; state = 'available'; }
        else {
          text = 'Bestelbaar op nabestelling - binnen 5-7 werkdagen verzonden';
          if (selected.expected && /^\d{4}-\d{2}-\d{2}$/.test(selected.expected) && selected.expected >= new Date().toISOString().slice(0, 10)) {
            text = `Bestelbaar op nabestelling - verwacht ${new Intl.DateTimeFormat('nl-NL', { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(`${selected.expected}T12:00:00`))}`;
          }
          state = 'available';
        }
      }
      status.textContent = text;
      status.dataset.state = state;
      root.dataset.singleUnavailable = soldOut ? 'true' : 'false';
      buyButtons.forEach(button => { button.hidden = Boolean(soldOut); });
      trigger.hidden = !soldOut;
      const stickyAction = root.querySelector('[data-atelier-sticky-action]');
      if (stickyAction) {
        if (!stickyAction.dataset.stockDefault) stickyAction.dataset.stockDefault = stickyAction.textContent;
        stickyAction.textContent = soldOut ? 'Voorraadmelding' : stickyAction.dataset.stockDefault;
      }
      form.querySelector('[data-restock-variant]').textContent = selected?.title || '';
      root.querySelectorAll('[data-variant-input]').forEach(input => {
        const index = Number(input.dataset.index.replace('option', '')) - 1;
        const matches = variants.filter(variant => variant.options.every((value, optionIndex) => value === (optionIndex === index ? input.value : selected?.options[optionIndex])));
        const unavailable = matches.length > 0 && matches.every(variant => !variant.available || (positions.get(String(variant.id))?.inStock === false && !variant.backorder));
        const label = root.querySelector(`label[for="${CSS.escape(input.id)}"]`);
        if (label) {
          label.dataset.stockUnavailable = String(unavailable);
          label.title = unavailable ? `${input.value}: uitverkocht, voorraadmelding mogelijk` : input.value;
        }
      });
    };
    root.addEventListener('variantChange', event => {
      selected = variants.find(variant => variant.id === event.detail.variant?.id);
      form.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      form.querySelector('[data-restock-message]').textContent = '';
      queueMicrotask(render);
    });
    trigger.addEventListener('click', () => {
      form.hidden = !form.hidden;
      trigger.setAttribute('aria-expanded', String(!form.hidden));
      if (!form.hidden) form.elements.email.focus();
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      const variant = selected;
      if (!variant || !form.reportValidity()) return;
      const submit = form.querySelector('[type="submit"]');
      const message = form.querySelector('[data-restock-message]');
      submit.disabled = true;
      message.textContent = 'Aanmelding opslaan...';
      try {
        const response = await fetch(`${base}storefront-restock`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'omit', signal: AbortSignal.timeout(15000),
          body: JSON.stringify({ slug: 'castlesonnl', variantId: String(variant.id), email: form.elements.email.value, consent: form.elements.consent.checked }),
        });
        if (!response.ok || !(await response.json()).ok) throw new Error('Subscription failed');
        if (selected?.id === variant.id) message.textContent = 'Je aanmelding is opgeslagen. Je ontvangt een e-mail zodra deze maat weer bestelbaar is.';
      } catch {
        if (selected?.id === variant.id) message.textContent = 'Aanmelden is niet gelukt. Probeer het opnieuw.';
      } finally { submit.disabled = false; }
    });
    render();
    fetch(`${base}storefront-availability?slug=castlesonnl&variants=${variants.map(variant => variant.id).join(',')}`, { credentials: 'omit', cache: 'no-store', signal: AbortSignal.timeout(12000) })
      .then(response => { if (!response.ok) throw new Error('Unavailable'); return response.json(); })
      .then(data => { if (data.version !== 1 || !Array.isArray(data.variants)) throw new Error('Invalid availability'); positions = new Map(data.variants.map(variant => [variant.id, variant])); })
      .catch(() => {})
      .finally(() => { loaded = true; render(); });
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();